import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import { convertSqlTimestampToDate } from "utils/UtilityFuncs";

export default function CShipping({ selectedCustomer }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Fetch shipments from API
  const getShipments = async (query) => {
    try {
      setLoading(true);
      const { data } = await API.post(
        "/sales/shipments",
        {
          page: 1,
          limit: 20,
          filterBy: "all",
          query: query?.trim(),
          customerId: selectedCustomer?.customerId,
        },
        { headers: authHeader() }
      );
      if (data.success) {
        setShipments(data.data);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const viewShipmentDetails = (shipment) => {
    navigate(`/sales/shipments/details?shipment-id=${shipment.shipmentId}`, {
      state: { shipment: shipment },
    });
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getShipments();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className="pt-3 px-3 horizontal-scrollable d-flex flex-grow-1 flex-column gap-3"
      style={{ borderRadius: 10, minHeight: "80vh", overflowY: "auto" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold mb-0">Shipment History</h4>
        <div className="d-flex align-items-center">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              getShipments(searchText);
            }}
            className="d-flex align-items-center me-2"
          >
            <input
              type="search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              className="form-control me-1"
              placeholder="Search here..."
            />
            <button type="submit" className="btn btn-info">
              Search
            </button>
            {searchText && searchText !== "" && (
              <button
                type="button"
                onClick={() => {
                  setSearchText("");
                  getShipments("");
                }}
                className="btn btn-danger ms-1"
              >
                Clear
              </button>
            )}
          </form>
        </div>
      </div>
      {loading && <Spinner />}
      {!loading && (
        <table className="table table-sm">
          <thead>
            <tr>
              <th>S-ID</th>
              <th>Created At</th>
              <th>Customer</th>
              <th>Status</th>
              <th>Tracking No</th>
              <th>Shipment Info</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {shipments.map((ship) => {
              // Parse shipping address
              let addr = ship.shippingAddress;

              // convert addr to JSON until addr is an object
              try {
                addr = JSON.parse(addr);
                while (typeof addr === "string") {
                  addr = JSON.parse(addr);
                }
              } catch (e) {
                addr = {};
              }

              // Build single-line address string
              const company =
                addr?.addressCompany &&
                ship?.customerName?.toLowerCase() ===
                  addr?.addressCompany?.toLowerCase()
                  ? ""
                  : addr?.addressCompany
                  ? addr.addressCompany + ", "
                  : "";
              const line1 = addr?.addressLine1 ? addr.addressLine1 + ", " : "";
              const line2 = addr?.addressLine2 ? addr.addressLine2 + ", " : "";
              const city = addr?.city ? addr.city + ", " : "";
              const state = addr?.state ? addr.state + ", " : "";
              const zip = addr?.zip ? addr.zip + ", " : "";
              const country = addr?.country ? addr.country + ", " : "";

              let customerName = ship?.customer?.customerName || "";
              let customerId = ship?.customer?.customerId || "";

              return (
                <tr
                  key={ship.shipmentId}
                  className={
                    ship.isVoided ? "text-decoration-line-through" : ""
                  }
                >
                  <td>S-{ship.shipmentId}</td>
                  <td>{convertSqlTimestampToDate(ship.createdAt)}</td>
                  <td className="text-truncate">
                    {/* {customerId ? `C-${customerId}` : ""}{" "} */}
                    {customerName}
                    {/* {truncateString(customerName, 50)} */}
                  </td>
                  <td>{ship.shipmentStatus}</td>
                  <td>{ship.trackingNo || ""}</td>
                  <td>
                    <span>
                      {company}
                      {line1}
                      {line2}
                      {city}
                      {state}
                      {zip}
                      {country}
                    </span>
                  </td>
                  <td className="text-center">
                    <button
                      onClick={() => viewShipmentDetails(ship)}
                      className="btn btn-sm btn-success"
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
